import { render, staticRenderFns } from "./BaseEnlargeableImage.vue?vue&type=template&id=1bf920ba&scoped=true"
import script from "./BaseEnlargeableImage.vue?vue&type=script&lang=js"
export * from "./BaseEnlargeableImage.vue?vue&type=script&lang=js"
import style0 from "./BaseEnlargeableImage.vue?vue&type=style&index=0&id=1bf920ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf920ba",
  null
  
)

export default component.exports